import { OWNER_ACCENT, OWNER_BORDER, OWNER_PANEL, OWNER_STATUS } from './ownerTheme'

type KpiCardProps = {
  label: string
  value: string
  deltaPct?: number
  active?: boolean
  onClick?: () => void
}

const formatDelta = (deltaPct: number) => {
  const sign = deltaPct >= 0 ? '+' : ''
  return `${sign}${deltaPct.toFixed(1)}%`
}

export default function KpiCard({ label, value, deltaPct, active, onClick }: KpiCardProps) {
  const isPositive = (deltaPct ?? 0) >= 0
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`w-full rounded-2xl border p-4 text-left transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--owner-accent)] ${
        active ? '' : 'hover:border-white/20'
      }`}
      style={{
        backgroundColor: OWNER_PANEL,
        borderColor: active ? OWNER_ACCENT : OWNER_BORDER,
        boxShadow: active ? `0 0 0 1px ${OWNER_ACCENT}55` : undefined,
      }}
    >
      <div className="text-[11px] uppercase tracking-[0.2em] text-white/55">{label}</div>
      <div className="mt-2 text-2xl font-semibold text-white">{value}</div>
      {deltaPct !== undefined && (
        <div className="mt-3 text-xs" style={{ color: isPositive ? OWNER_STATUS.ok : OWNER_STATUS.bad }}>
          {formatDelta(deltaPct)} vs previous
        </div>
      )}
    </button>
  )
}
